import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, Tree, Table, Empty,Checkbox } from 'antd';
import moment from 'moment';
import './styles.css';

import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';

import DetalleProductoServicioModal from './FormModal/DetalleProductoServicioModal';
import DetalleReferenciaModal from './FormModal/DetalleReferenciaModal';

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModalVer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }


    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    render() {
        
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        //var arrayTemp = [];
        //var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        //for (var i = 0; i < this.props.formValues.listaComprobanteDetalle.length; i++) {
        //    var item = this.props.formValues.listaComprobanteDetalle[i];
        //    var existItem = arrDetalle.filter(m => { return m.identifier === item.idProducto })

        //    var d = {
        //        identifier: 'psd' + item.idProducto,
        //        flagAfecto: false,
        //        idProducto: item.idProducto,
        //        precioUnitario: existItem.length === 0 ? item.precioUnitario : existItem[0].precioUnitario,
        //        cantidad: existItem.length === 0 ? item.cantidad : existItem[0].cantidad,
        //        subTotal: existItem.length === 0 ? item.subTotal : existItem[0].subTotal,
        //        igv: existItem.length === 0 ? item.igv : existItem[0].igv,
        //        total: existItem.length === 0 ? item.total : existItem[0].total
        //    };

        //    arrayTemp.push(d);
        //}

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('arrDetalle', { initialValue: [] });
        //getFieldDecorator('arrDetalle', { initialValue: arrayTemp });
        //getFieldDecorator('arrDetalle', { initialValue: this.props.formValues.listaComprobanteDetalle });
        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });
        return (
            <Modal
                title="Ver Orden de Compra"
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                width="1100px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('idRequerimiento', { initialValue: this.props.formValues.idRequerimiento })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => this.props.onChange('fechaStr', value)}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Dias / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('diasVencimiento', {
                                            initialValue: this.props.formValues.diasVencimiento,
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_NUMBER),
                                                message: "Formato incorrecto"
                                            }]
                                        })(
                                            <Input
                                                style={{ textAlign: 'right' }}
                                                placeholder="Ingresar d�as de vencimiento"
                                                autoComplete="off"
                                                className="first-input"
                                                onBlur={(e) => this.props.onChange('diasVencimiento', e.target.value)}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaVencimientoStr', {
                                            initialValue: moment(this.props.formValues.fechaVencimientoStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                className="second-input"
                                                onChange={(moment, value) => this.props.onChange('fechaVencimientoStr', value)}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('nombreMoneda', {
                                    initialValue: this.props.formValues.nombreMoneda,
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Proveedor">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('proveedor', {
                                            initialValue: this.props.formValues.proveedor
                                        })(
                                            <Input readOnly={true} />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Dirección">
                                {getFieldDecorator('direccionEstablecimiento', {
                                    initialValue: this.props.formValues.direccionEstablecimiento
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('nombreProyecto', {
                                    initialValue: this.props.formValues.nombreProyecto 
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Sucursal">
                                {getFieldDecorator('nombreEstablecimientoSucursal', {
                                    initialValue: this.props.formValues.nombreEstablecimientoSucursal 
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
            {/*             <div className="col-md-6 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('nombreAlmacen', {
                                    initialValue: this.props.formValues.nombreAlmacen 
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        
                        <div className="col-md-9 form-group">
                            <Form.Item label="Condición de Pago">
                                {getFieldDecorator('condicion', {
                                    initialValue: this.props.formValues.condicion
                           
                                })(
                                    <Input
                                        placeholder="Ingresar Condición"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                        <Form.Item label="Plazo Entrega">
                                {getFieldDecorator('plazo', {
                                    initialValue: this.props.formValues.plazo
                           
                                })(
                                    <Input
                                        placeholder="Ingresar Plazo Entrega"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">

                                    <Table
                                        className={'table-producto'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        rowKey={record => record.idProducto}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='No se han agregado productos'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Código',
                                                dataIndex: 'codigo',
                                                key: 'codigo',
                                                align: 'center',
                                                width: 80,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Nombre',
                                                dataIndex: 'nombre',
                                                key: 'nombre',
                                                width: 300,
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Unidad Medida',
                                                dataIndex: 'nombreUnidadMedida',
                                                key: 'nombreUnidadMedida',
                                                width: 120,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Valor Unitario',
                                                dataIndex: 'precioUnitario',
                                                key: 'precioUnitario',
                                                align: 'center',
                                                width: 90
                                            },
                                            {
                                                title: 'Afecto',
                                                dataIndex: 'flagAfecto',
                                                key: 'flagAfecto',
                                                align: 'center',
                                                width: 62,
                                                render: (value, row) => {
                                                    return (
                                                        <div>
                                                            <Checkbox
                                                                disabled={true} 
                                                                checked={value}
                                                                >
                                                            </Checkbox>
                                                        </div>
                                                    );
                                                }
                                            },
                                            {
                                                title: 'Exonerado',
                                                dataIndex: 'flagExonerado',
                                                key: 'flagExonerado',
                                                align: 'center',
                                                width: 80,
                                                render: (value, row) => {
                                                    return (
                                                        <div>
                                                            <Checkbox
                                                                disabled={true} 
                                                                checked={value}
                                                                >
                                                            </Checkbox>
                                                        </div>
                                                    );
                                                }
                                            },
                                            {
                                                title: 'Gratuito',
                                                dataIndex: 'flagGratuito',
                                                key: 'flagGratuito',
                                                align: 'center',
                                                width: 62,
                                                render: (value, row) => {
                                                    return (
                                                        <div>
                                                            <Checkbox
                                                                disabled={true} 
                                                                checked={value}
                                                                >
                                                            </Checkbox>
                                                        </div>
                                                    );
                                                }
                                            },
                                            {
                                                title: 'Cantidad',
                                                dataIndex: 'cantidad',
                                                key: 'cantidad',
                                                align: 'center',
                                                width: 90
                                            },
                                            {
                                                title: 'Sub Total',
                                                dataIndex: 'subTotal',
                                                key: 'subTotal',
                                                align: 'center',
                                                width: 90
                                            },
                                            {
                                                title: 'IGV',
                                                dataIndex: 'igv',
                                                key: 'igv',
                                                align: 'center',
                                                width: 80
                                            },
                                            {
                                                title: 'Total',
                                                dataIndex: 'total',
                                                key: 'total',
                                                fixed: 'right',
                                                align: 'center',
                                                width: 90
                                            }
                                        ]}
                                    />

                                </TabPane>

                                <TabPane tab="Detalle de Referencias" key="2">
                                    <Table
                                        className={'table-referencia'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        rowKey={record => record.identifier}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='Pulse el bot�n "+ Agregar".'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Tipo Comprobante',
                                                dataIndex: 'nombreTipoComprobante',
                                                key: 'nombreTipoComprobante',
                                                align: 'center',
                                                width: 350,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Serie',
                                                dataIndex: 'serie',
                                                key: 'serie',
                                                width: 100,
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Documento',
                                                dataIndex: 'documento',
                                                key: 'documento',
                                                width: 120,
                                                ellipsis: true
                                            }
                                        ]}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-md-6"}>

                        </div>
                        <div className="col-md-3 form-group">

                        </div>
                        <div className="col-md-3 pt-10">

                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>Sub Total</label>
                                    <div>{this.props.formValues.sumaSubTotal.toFixed(2)}</div>
                                </div>
                            </div>
                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>IGV</label>
                                    <div>{this.props.formValues.sumaIgv.toFixed(2)}</div>
                                </div>
                            </div>
                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>Total</label>
                                    <div>{this.props.formValues.sumaTotal.toFixed(2)}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default Form.create()(FormModalVer)